<script>
</script>

<style>
  .loading-placeholder {
    min-height: 1rem;
    min-width: 8rem;

    border-radius: 0.2rem;

    background: linear-gradient(to right, #ffffff10 4%, #ffffff4f 20%, #ffffff4f 30%, #ffffff10 50%);
    background-position-x: -100%;
    background-size: 200% 100%;
    background-repeat: repeat-x;
    animation: shimmer 2s infinite;
  }

  @keyframes shimmer {
    0% {
      background-position-x: 100%;
    }

    100% {
      background-position-x: -100%;
    }
  }
</style>

<div class="loading-placeholder">&nbsp;</div>
